module.exports = __webpack_public_path__ + "img/account-setting.4a0cbb05.svg";